import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { ToWords } from "to-words/en-IN";
import { getReactPdfColors } from "@/theme/reactPdfColors";
import { readStoredTenantBrandingIdentity } from "@/utils/tenant-branding-cache";
import { formatTrustRegNo } from "@/utils/tenant-trust-subtitle";
import "./register-fonts";

const toWords = new ToWords();

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    fontSize: 12,
  },
});

export type SabilReceiptLine = {
  date: string;
  receiptNo: string | number;
  amount: number;
  mode: string;
};

export type ReceiptsPdfProps = {
  receipt: SabilReceiptLine;
  HOFITS: string | number;
  HOFName: string;
  markaz?: string;
  total: string | number;
  /** Defaults to cached tenant fields from `GET /tenant-branding/me`. */
  tenantName?: string;
  trustName?: string;
  trustId?: string;
};

export function ReceiptsPDF({
  receipt,
  HOFITS,
  HOFName,
  markaz = "",
  total,
  tenantName: tenantNameProp,
  trustName: trustNameProp,
  trustId: trustIdProp,
}: ReceiptsPdfProps) {
  const cached = readStoredTenantBrandingIdentity();
  const tenantName = tenantNameProp ?? cached.tenantName;
  const trustName = trustNameProp ?? cached.trustName;
  const trustId = trustIdProp ?? cached.trustId;
  const trustReg = formatTrustRegNo(trustId);
  const pdfColors = getReactPdfColors();
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View
          style={{
            margin: "20px",
            padding: "10px",
            border: "1px solid black",
            flexDirection: "column",
          }}
        >
          <Text
            style={{
              marginTop: "5px",
              fontFamily: "Roboto-Bold",
              fontSize: "12px",
              alignSelf: "center",
            }}
          >
            {tenantName}
          </Text>
          {trustName.trim() ? (
            <Text
              style={{
                marginTop: "4px",
                fontFamily: "Roboto-Bold",
                fontSize: "11px",
                alignSelf: "center",
              }}
            >
              {trustName.trim()}
            </Text>
          ) : null}
          {trustReg ? (
            <Text
              style={{
                marginTop: "2px",
                fontFamily: "Roboto-Regular",
                fontSize: "10px",
                alignSelf: "center",
              }}
            >
              {trustReg}
            </Text>
          ) : null}
          <Text
            style={{
              marginTop: "15px",
              fontFamily: "Roboto-Bold",
              fontSize: "18px",
              alignSelf: "center",
              color: pdfColors.heading,
            }}
          >
            NIYAAZ TANZEEM1
          </Text>
          <Text
            style={{
              marginTop: "15px",
              fontFamily: "Roboto-Bold",
              fontSize: "12px",
              alignSelf: "center",
            }}
          >
            Hoob Receipt
          </Text>
          <Text
            style={{
              marginTop: "10px",
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              alignSelf: "flex-end",
            }}
          >
            {`${receipt.date}, RNo: ${receipt.receiptNo}`}
          </Text>
          <Text
            style={{
              marginTop: "10px",
              fontFamily: "Roboto-Bold",
              fontSize: "16px",
              alignSelf: "flex-start",
              color: pdfColors.accentText,
            }}
          >
            {`ITS ID : ${HOFITS}`}
          </Text>
          <Text
            style={{
              marginTop: "10px",
              fontFamily: "Roboto-Bold",
              fontSize: "14px",
              alignSelf: "flex-start",
            }}
          >
            {`Name : ${HOFName}`}
          </Text>
          <Text
            style={{
              marginTop: "10px",
              fontFamily: "Roboto-Bold",
              fontSize: "13px",
              alignSelf: "flex-start",
            }}
          >
            {`Markaz : ${markaz} | Takhmeen Amount : ${total}`}
          </Text>
          <Text
            style={{
              marginTop: "20px",
              fontFamily: "Roboto-Regular",
              fontSize: "14px",
            }}
          >
            Received with Thanks your contribution of
            <Text style={{ fontFamily: "Roboto-Bold" }}>{` Rs. ${receipt.amount} (${toWords.convert(
              receipt.amount
            )} by ${receipt.mode})`}</Text>
            {" towards Niyaz Hoob."}
          </Text>
          <Text
            style={{
              marginTop: "15px",
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              alignSelf: "flex-start",
            }}
          >
            The purpose of this Hoob is to do Niyaz Jaman during Shere Ramadan 1444
          </Text>
          <Text
            style={{
              marginTop: "15px",
              marginBottom: "20px",
              fontFamily: "Roboto-Italic",
              fontSize: "8px",
              alignSelf: "flex-start",
              color: pdfColors.muted,
            }}
          >
            This is a computer generated receipt and does not require a signature
          </Text>
        </View>
      </Page>
    </Document>
  );
}
